import gsap from "gsap";

export const animationCover = ({
    elements,
    reverse,
    onCompleteShow,
    onCompleteHide,
}) => {
    const { title, frame, decoration, summary } = elements;

    const options = {
        hide: {
            duration: 0.4,
            ease: "power2",
            overwrite: "auto",
        },
        show: {
            duration: 0.45,
            ease: "power2",
            overwrite: "auto",
        },
    };

    return {
        mobile: {
            hide() {
                gsap.to(title, { ...options.hide, y: "-10%", autoAlpha: 0 });
                gsap.to(frame, {
                    ...options.hide,
                    y: "-10%",
                    onComplete: onCompleteHide,
                });
                gsap.to(decoration, {
                    ...options.hide,
                    y: "-100%",
                    autoAlpha: 0,
                });
                gsap.to(summary, { ...options.hide, y: "-10%", autoAlpha: 0 });
            },
            hideBack() {
                const options = {
                    duration: 0.4,
                    ease: "power2",
                    overwrite: "auto",
                };

                gsap.to(title, { ...options.hide, y: "10%", autoAlpha: 0 });
                gsap.to(frame, {
                    ...options.hide,
                    y: "10%",
                    onComplete: onCompleteHide,
                });
                gsap.to(decoration, {
                    ...options.hide,
                    y: "100%",
                    autoAlpha: 0,
                });
                gsap.to(summary, { ...options.hide, y: "10%", autoAlpha: 0 });
            },
            show() {
                gsap.to(title, { ...options.show, y: 0, autoAlpha: 1 });
                gsap.to(frame, {
                    ...options.show,
                    y: 0,
                    onComplete: onCompleteShow,
                });
                gsap.to(decoration, { ...options.show, y: 0, autoAlpha: 1 });
                gsap.to(summary, { ...options.show, y: 0, autoAlpha: 1 });
            },
        },
        desktop: {
            hide() {
                gsap.to(title, {
                    ...options.hide,
                    x: reverse ? "10%" : "-10%",
                    autoAlpha: 0,
                });
                gsap.to(frame, {
                    ...options.hide,
                    x: reverse ? "15.5%" : "-15.5%",
                    onComplete: onCompleteHide,
                });
                gsap.to(decoration, {
                    ...options.hide,
                    x: reverse ? "104%" : "-104%",
                });
                gsap.to(summary, {
                    ...options.hide,
                    x: reverse ? "-15.5%" : "15.5%",
                    autoAlpha: 0,
                });
            },
            show() {
                gsap.to(title, { ...options.show, x: 0, autoAlpha: 1 });
                gsap.to(frame, {
                    ...options.show,
                    x: 0,
                    onComplete: onCompleteShow,
                });
                gsap.to(decoration, { ...options.show, x: 0 });
                gsap.to(summary, { ...options.show, x: 0, autoAlpha: 1 });
            },
        },
    };
};
